import React, { useState } from "react";
import "../assets/styles/login-page.css";
import rasedLogo from "../assets/images/rased-bank-logo.png";
import { useAuth } from "../auth/AuthContext";
import theme from "../theme/theme";
import Footer from "../components/Footer";
import ErrorModal from "../components/ErrorModal";
import { useNavigate } from "react-router-dom";
function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { empLogin} = useAuth();

  const handleLoginError = () => {
    setShowErrorModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await empLogin(username, password);
    } catch (error) {
      setShowErrorModal(true)
      setErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    {showErrorModal && (
       <ErrorModal
       show={showErrorModal}
       onClose={() => setShowErrorModal(false)}
       title="خطأ"
       message={errorMessage}
     />
    )}
     
       <div className="login-page-body-container">
        <div className="login-page-left-side">
          <img src={rasedLogo} height="600" width="620" alt="" />
        </div>
        <div className="login-page-right-side d-flex flex-column">
          <img src={rasedLogo} alt=""  width="200" height="200" />
          <div className="form-container">
            <h2>دخول</h2>
            <form >
              <div className="group">
                <input
                  type="text"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <span className="bar" />
                <label className="form-label primary-color">رقم المستخدم</label>
              </div>
              <div className="group">
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span className="highlight" />
                <span className="bar" />
                <label className="form-label">كلمة المرور</label>
              </div>
              <button
                className="button-md primary-bg primary-hover col-12"
                disabled={isLoading}
                onClick={handleSubmit}
              >
                {isLoading ? <Spinner /> : "دخول"}
              </button>
            </form>
              <button 
                className="mt-4 button-md primary-outline-bg  primary-hover col-12"
              onClick={()=>navigate('/reset-password')} >
                نسيت كلمة المرور ؟
              </button>
              <button 
                className="mt-4 button-md primary-outline-bg  primary-hover col-12"
              onClick={()=>navigate('/register')} >
                انشاء حساب
              </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
const Spinner = () => (
  <div
    className="spinner"
    style={{
      border: `4px solid ${theme.colors.light}`,
      borderLeftColor: theme.colors.secondary,
      borderRadius: "50%",
      width: "24px",
      height: "24px",
      margin: "auto",
      animation: "spin 1s linear infinite",
    }}
  ></div>
);

export default LoginPage;
